<form autocomplete="off" [formGroup]="form" (ngSubmit)="save()">
    <h4>Detalle de publicación:
        <ng-container *ngIf="publication"><small>{{publication.name}}</small></ng-container>
    </h4>
    <div *ngIf="movesLog && accessMP" class="p-3 mb-3 rounded" style="background-color: #f8f9fa; border: 1px solid #dee2e6;">
        <div class="form-group row">
            <label class="col-md-2 col-form-label">Creado</label>
            <div class="col-md-4">
                <p class="form-control-plaintext text-left">
                    {{ movesLog['creationLog']?.nameUser
                    ? (movesLog['creationLog']?.nameUser + ' - ' + (movesLog['creationLog']?.createdAt |
                    date:'dd/MM/yyyy HH:mm'))
                    : 'No se cuenta con registros del creador.' }}
                </p>
            </div>
            <label class="col-md-2 col-form-label">Editado</label>
            <div class="col-md-4">
                <p *ngIf="movesLog['editLog']" class="form-control-plaintext text-left">
                    {{ movesLog['editLog']?.nameUser }} - {{ movesLog['editLog']?.updatedAt | date:'dd/MM/yyyy HH:mm' }}
                </p>
                <p *ngIf="!movesLog['editLog']" class="form-control-plaintext text-left text-muted">
                    No se cuenta con registros de modificaciones.
                </p>
            </div>
        </div>
    </div>
    <hr>

    <div class="form-group row">

        <div class="textOnInput col-12 col-md-12">
            <label class="form-label" for="inputText">Título corto</label>
            <input class="form-control form-input" type="text" formControlName="name" autocomplete="off"
                [class.is-invalid]="campoNoValido('name')">
            <small class="text-danger" *ngIf="campoNoValido('name')">Este campo es requerido</small>
        </div>

        <div class="textOnInput col-12">
            <label class="form-label" for="inputText">Título largo</label>
            <input class="form-control form-input" type="text" formControlName="shortname" autocomplete="off"
                [class.is-invalid]="campoNoValido('shortname')">
            <small class="text-danger" *ngIf="campoNoValido('shortname')">Este campo es requerido</small>
        </div>

        <div class="textOnInput col-12 col-md-3">
            <label class="form-label" for="inputText">Año</label>
            <input class="form-control form-input" type="text" formControlName="year" autocomplete="off"
                [class.is-invalid]="campoNoValido('year')" readonly>
            <small class="text-danger" *ngIf="campoNoValido('year')">Este campo es requerido</small>
        </div>

        <div class="textOnInput col-6 col-md-6 col-lg-3">
            <label class="form-label" for="inputText">Fecha de publicación</label>
            <input class="form-control form-input" type="date" formControlName="publication_date" autocomplete="off"
                [class.is-invalid]="campoNoValido('publication_date')">
            <small class="text-danger" *ngIf="campoNoValido('publication_date')">Este campo es requerido</small>
        </div>

        <div class="textOnInput col-6 col-md-6 col-lg-3">
            <label class="form-label" for="inputText">Editorial</label>
            <input class="form-control form-input" type="text" formControlName="editorial" autocomplete="off"
                [class.is-invalid]="campoNoValido('editorial')">
            <small class="text-danger" *ngIf="campoNoValido('editorial')">Este campo es requerido</small>
        </div>

        <div class="textOnInput col-12 col-md-3">
            <label class="form-label" for="inputText">N°páginas</label>
            <input class="form-control form-input" type="text" formControlName="pages" autocomplete="off"
                [class.is-invalid]="campoNoValido('pages')">
            <small class="text-danger" *ngIf="campoNoValido('pages')">Este campo es requerido</small>
        </div>

        <div class="textOnInput col-12">
            <label class="form-label" for="inputText">Imagen portada</label>
            <div class="label-container">
                <div class="row align-items-center">
                    <div class="col-md-9">
                        <div class="input-group">
                            <div class="input-group-append">
                                <button class="btn btn-outline-primary custom-rounded-button" type="button"
                                    (click)="fileInput.click()">
                                    Cargar portada
                                </button>
                            </div>
                            <input type="text" disabled class="form-control" placeholder="Imagen"
                                formControlName="urlimg">
                        </div>
                        <input #fileInput class="form-file" type="file" id="input-file" (change)="onFileChange($event)"
                            accept="image/png, .jpg, .webp" style="display: none;">
                    </div>
                    <div class="col-md-3">
                        <ng-container *ngIf="form.get('urlimg').value != null">
                            <ng-container *ngIf="isUploadDir">
                                <img class="img-fluid" src="{{URL}}{{form.get('urlimg').value}}" alt=""
                                    style="height: 120px; width:100px">
                            </ng-container>
                            <ng-container *ngIf="!isUploadDir">
                                <img src="{{form.get('urlimg').value}}" alt="No se ha cargado una imagen"
                                    style="height: 50px;">
                            </ng-container>
                        </ng-container>
                    </div>
                </div>
            </div>
        </div>

        <div class="textOnInput col-12">
            <label class="form-label" for="inputText">Description</label>
            <textarea class="form-control" formControlName="description" autocomplete="off"
                [class.is-invalid]="campoNoValido('description')" rows="6"></textarea>
            <small class="text-danger" *ngIf="campoNoValido('description')">Este campo es requerido</small>
        </div>

        <div class="textOnInput col-12">
            <label class="form-label" for="inputText">Contenido</label>
            <textarea class="form-control" formControlName="contents" autocomplete="off"
                [class.is-invalid]="campoNoValido('contents')" rows="6" (keydown)="onKeyDown($event)"></textarea>
            <small class="text-danger" *ngIf="campoNoValido('contents')">Este campo es requerido</small>
        </div>

        <div class="col-12">
            <div class="alert alert-success" role="alert">
                <p class="text-left">Para formatear el contenido, copie su lista numerada y luego sitúese al final
                    del <b>último elemento</b>. A continuación, presione la tecla 'Enter' <b>una vez</b>. Con esta
                    acción, se generará una lista con código <b>HTML</b> que permitirá organizar la vista.<br>
                    Para resaltar palabras en negrita puede hacer uso de la etiqueta <b>HTML</b> de la forma
                    <code>&lt;b&gt;palabra que quiero en negrita&lt;/b&gt;</code>
                </p>
            </div>
        </div>

        <div class="textOnInput col-12">
            <label class="form-label" for="inputText">Cita biliografica</label>
            <input class="form-control form-input" type="text" formControlName="appointment" autocomplete="off"
                [class.is-invalid]="campoNoValido('appointment')">
            <small class="text-danger" *ngIf="campoNoValido('appointment')">Este campo es requerido</small>
        </div>

        <div class="textOnInput col-6 col-md-6">
            <label class="form-label" for="inputText">Clasificación</label>
            <select class="form-select form-input" formControlName="idclasification"
                [class.is-invalid]="campoNoValido('idclasification')">
                <option selected [ngValue]="null">Clasificación...</option>
                <option *ngFor="let c of clasdata" value="{{c.id}}">
                    {{c.title}}
                </option>
            </select>
            <small class="text-danger" *ngIf="campoNoValido('idclasification')">Este campo es requerido</small>
        </div>

        <div class="textOnInput col-6 col-md-6">
            <label class="form-label" for="inputText">URL documento</label>
            <input class="form-control form-input" type="text" formControlName="urlfile" autocomplete="off"
                [class.is-invalid]="campoNoValido('urlfile')">
            <small class="text-danger" *ngIf="campoNoValido('urlfile')">Este campo es requerido</small>
        </div>

        <div class="textOnInput col-12">
            <label class="form-label" for="inputText">Equipo</label>
            <input class="form-control form-input" type="text" formControlName="team" autocomplete="off"
                [class.is-invalid]="campoNoValido('team')">
            <small class="text-danger" *ngIf="campoNoValido('team')">Este campo es requerido</small>
        </div>

        <div class="textOnInput col-12">
            <label class="form-label" for="inputText">Temáticas vinculadas</label>
            <div class="label-container">
                <div class="textOnInput col-12 col-md-6 mb-2">
                    <label class="form-label">Lista de temáticas</label>
                    <select class="form-select input-select" formControlName="selectedTematic" (change)="addTematic()">
                        <option selected [ngValue]="null">Tematicas</option>
                        <option *ngFor="let t of temdata" [ngValue]="t">{{t.title}}</option>
                    </select>
                </div>
                <div class="col-12">
                    <div class="row px-3">
                        <ng-container formArrayName="tematics">
                            <div class="btn-related mt-2"
                                *ngFor="let tematicFormGroup of selectedTematicsControls.controls; index as i">
                                {{ tematicFormGroup.value.title}}
                                <button class="btn-cross" type="button" (click)="triggerDeleteTematicConfirmation(i)">
                                    <i class="fa fa-times"></i>
                                </button>
                            </div>
                        </ng-container>
                    </div>
                </div>
                <div *ngIf="showDeleteConfirmationTematic" class="confirmation-dialog">
                    <div>¿Estás seguro que quieres eliminar este elemento?</div>
                    <button (click)="confirmDeleteTematic()">Sí</button>
                    <button (click)="cancelDeleteTematic()">No</button>
                </div>
            </div>
        </div>

        <div class="textOnInput col-12">
            <label class="form-label" for="inputText">Visible/oculto</label>
            <div class="label-container align-switch">
                <div class="form-check form-switch">
                    <input class="form-check-input" type="checkbox" id="switch1" formControlName="status">
                </div>
            </div>
        </div>

    </div>

    <div class="row">
        <div class="col-12">
            <div class="d-flex justify-content-start">
                <div class="me-2">
                    <button type="button" class="btn btn-outline-secondary btn-block" (click)="cancel()">
                        Cancelar
                    </button>
                </div>
                <div>
                    <button type="submit" class="btn btn-outline-primary">Guardar</button>
                </div>
            </div>
        </div>
    </div>

</form>